// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6f6da0eb","455":"6bffce6d","977":"9490be9a"}[chunkId] + ".chunk.js";
};